import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ChecklistMember } from 'contracts/ChecklistMembers';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CHECKLIST_MEMBER_',
  }
);

export interface FetchChecklistMemberState {
  data: ChecklistMember | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchChecklistMemberRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ChecklistMember;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchChecklistMemberState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchChecklistMemberState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchChecklistMemberState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchChecklistMemberState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchChecklistMemberState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchChecklistMember = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchChecklistMemberTypes = Types;
export const FetchChecklistMemberActions = Creators;